<template>
    <v-select label="name"
              :filterable="false"
              :options="options"
              v-model="selected"
              @search="onSearch">
      <template slot="no-options">
        escribe para buscar pallets
      </template>
      <template slot="option" slot-scope="option">
        <div class="d-center">
          {{ option.number }} - {{option.container}}
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">
          {{ option.number }} - {{option.container}}
        </div>
      </template>
    </v-select>

</template>

<script>
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css';
  export default {
    name: "searchPallets",
    components: {
      vSelect
    },
    data() {

      return {
        data:0,
        selected: null,
        modalShown: false,
        numberLabel: 0,
        typeLabel: "",
        contentPrint: "",
        options: [],



      }
    },
    watch: {
      selected(){
        this.$emit('selected', this.selected)
      }
    },
    methods: {
      onSearch(search, loading) {
        loading(true);
        this.search(loading, search, this);
      },

      search: _.debounce((loading, search, vm) => {

        vm.$axios.get (`/api/v1/pallet/all_pallets/?q=${escape(search)}`)
          .then(res => {
            vm.options = res.data;
            loading(false);
          })
        .catch(error => {
          console.log(error.response)
        });
      }, 350),
    }

  }
</script>

<style>
  .style-chooser .vs__search::placeholder,
  .style-chooser .vs__dropdown-toggle,
  .style-chooser .vs__dropdown-menu {
    /*display: inline-block;*/
    /*width: 100%;*/
    min-height: calc(1.5em + 0.75rem + 2px);
    /*padding: 0.375rem 1.75rem 0.375rem 0.75rem;*/
    font-size: 0.6875rem;
    font-weight: 400;
    /*line-height: 1.5;*/
    color: #5c6873;
    /*vertical-align: middle;*/
    /*background-color: #fff;*/
    border: 1px solid #e4e7ea;
    /*border-radius: 0.25rem;*/
    /*-webkit-appearance: none;*/

  }

  .style-chooser .vs__clear,
  .style-chooser .vs__open-indicator {
    fill: #394066;
  }


  img {
    height: auto;
    max-width: 2.5rem;
    margin-right: 1rem;
  }

  .d-center {
    display: flex;
    align-items: center;
  }

  .selected img {
    width: auto;
    max-height: 23px;
    margin-right: 0.5rem;
  }

  .v-select .dropdown li {
    border-bottom: 1px solid rgba(112, 128, 144, 0.1);
  }

  .v-select .dropdown li:last-child {
    border-bottom: none;
  }

  .v-select .dropdown li a {
    padding: 10px 20px;
    width: 100%;
    font-size: 1.25em;
    color: #3c3c3c;
  }

  .v-select .dropdown-menu .active > a {
    color: #fff;
  }


</style>
